<template>
<ProjectStructure>
  <template #sidebar-left>
    <div
    class="color-white-04"
      >
      {{$t('Project.Structure.SpatialStructure.Header')}}
      <!-- <v-btn
        small
        @click="$refs.uploadIFC.click()"
        >
        IFC import
      </v-btn> -->
      <input
        v-show="false"
        ref="uploadIFC"
        type="file"
        accept=".ifc"
        @change="selectIFC($refs.uploadIFC.files[0])"
        />
    </div>
    <div style="position: relative; padding-bottom: 30px">
    <ProjectStructureTree
      :isEditMode="isEditMode && select_spatial_el_ta_id === -1"
      :parent="project"
      :child_elements="getChildElements({parent_type: 'projects', parent_id: project_id})"
      :selected_tree_element="$route.name === 'ProjectStructureDetails'?{type: $route.params.type, id: $route.params.structure_id}:false"
      :all_selected_elements="getAllSelectedElements({project_id: project_id})"
      :train_selected_elements="select_spatial_el_train_id !== -1?getAllSelectedElements({project_id: project_id, train_id: select_spatial_el_train_id}):[]"
      :ta_selected_elements="select_spatial_el_ta_id !== -1?getUObject({type: 'taktareas', id: select_spatial_el_ta_id}).elements:[]"
      :ta_hovered_elements="hover_ta_id !== -1?getUObject({type: 'taktareas', id: hover_ta_id}).elements:[]"
      :select_spatial_el_ta_id="select_spatial_el_ta_id"
      :hover_el_id="hover_el_id"
      :parent_color_index="0"
      @closeWrapper="updateUDObject({
          url: [
            {[$event.type]: $event.id},
          ],
          update: {
            closed: !$event.closed
          }
        })"
      @draggableUpdate="updateUObject({
          url: [
            {[$event.evt.item.id.split('#')[0]]: $event.evt.item.id.split('#')[1]},
          ],
          url_prefix: `/projects/${project_id}/projectstructure`,
          update: {
            order_index: ($event.evt.newIndex + ($event.evt.newIndex > $event.evt.oldIndex?1:0)) * 10 + 5
          },
        }).then(() => {
          updateTreeOrderIndex($event.parent)
          })"
      @draggableRemove="
            updateUObjectParent({
              url: [
                {[$event.evt.from.id.split('#')[0]]: parseInt($event.evt.from.id.split('#')[1])},
                {[$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1])},
                {changeparent: ''}
              ],
              url_prefix: `/projects/${project_id}/projectstructure`,
              update: {
                target_type: $event.evt.to.id.split('#')[0],
                target_id: parseInt($event.evt.to.id.split('#')[1]),
                parent: {
                  type: $event.evt.to.id.split('#')[0],
                  id: parseInt($event.evt.to.id.split('#')[1])
                }
              },

            }).then(() => {
              updateUObject({
                  url: [
                    {[$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1])},
                  ],
                  url_prefix: `/projects/${project_id}/projectstructure`,
                  update: {
                    order_index: $event.evt.newIndex * 10 + 5,
                    /* parent: {type: $event.evt.to.id.split('#')[0], id: $event.evt.to.id.split('#')[1]} */
                  }
                }).then(() => {
                  updateUDObject({
                      url: [
                        {[$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1])},
                      ],
                      url_prefix: `/projects/${project_id}/projectstructure`,
                      update: {
                        parent: {type: $event.evt.to.id.split('#')[0], id: $event.evt.to.id.split('#')[1]}
                      }
                    }).then(() => {
                      updateTreeOrderIndex($event.parent)
                      })
                })
          })
        "
        @draggableAdd="updateTreeOrderIndex($event.parent)"
        @clickAddElement="createUObject({
          url: [
            {[$event.parent.type]: $event.parent.id},
            {[$event.element.type]: ''},
            {showWithEntitiesNormalized: ''}
          ],
          url_prefix: `/projects/${project_id}/projectstructure`,
          u_object: JSON.parse(JSON.stringify(Object.assign(spatial_containers.concat(spatial_elements).find(el => el.name === $event.element.name), {order_index: 5, parent: {type: $event.parent.type, id: $event.parent.id}})))
          }).then(() => {
            updateTreeOrderIndex($event.parent)
            })
          "
        @deleteTreeElement="
        removeElementsFromTaktareas({
          type: $event.type,
          id: $event.id,
          }).then(() => {
            deleteUObject({
              url: [
                {[$event.parent.type]: $event.parent.id},
                {[$event.type]: $event.id}
              ],
              url_prefix: `/projects/${project_id}/projectstructure`,
            })
          })"
        @changeValue="updateUObject({
            url: [
              {[$event.element.type]: $event.element.id}
            ],
            url_prefix: `/projects/${project_id}/projectstructure`,
            update: {
              [$event.key]: $event.value
            }
          })"
        @addElement="addUObjects({
            url: [
              {projects: project_id},
              {trains: 0},
              {taktareas: select_spatial_el_ta_id},
              {add: ''}
            ],
            u_objects: {
              target_type: 'elements',
              target_ids: [$event.id]
            }
          })"
        @removeElement="removeUObjects({
            url: [
              {projects: project_id},
              {trains: 0},
              {taktareas: select_spatial_el_ta_id},
              {remove: ''}
            ],
            u_objects: {
              target_type: 'elements',
              target_ids: [$event.id]
            }
          })"
        @enterElement="elMouseEnter($event)"
        @leaveElement="elMouseLeave()"
        @treeElementClicked="isEditMode && select_spatial_el_ta_id !== -1 && $event.type !== 'elements'?
        selectAllSpatialContainerElements(getAllChildElements({
          parent_type: $event.type,
          parent_id: $event.id,
        })):''
        "
      />
      <!-- @treeElementClicked="$router.push({
        name: 'ProjectStructureDetails',
        params: {
          type: $event.type,
          structure_id: $event.id
        }
      })" -->
    </div>
  </template>
  <template #sidebar-left-footer v-if="isEditMode && select_spatial_el_ta_id === -1">
    <draggable
      :group="{name: 'spatial_containers', pull: 'clone', put: false}"
      :sort="false"
      animation="300"
      forceFallback="true"
      fallbackOnBody="true"
      :value="spatial_containers"
      @end="createUObject({
        url: [
          {[$event.to.id.split('#')[0]]: $event.to.id.split('#')[1]},
          {[$event.item.id.split('#')[0]]: ''},
          {showWithEntitiesNormalized: ''}
        ],
        url_prefix: `/projects/${project_id}/projectstructure`,
        u_object: JSON.parse(JSON.stringify(Object.assign(spatial_containers[$event.oldIndex], {order_index: $event.newIndex * 10 + 5, parent: {type: $event.to.id.split('#')[0], id: parseInt($event.to.id.split('#')[1])}})))
        })
        "
      >
      <!-- .then((id) => {
        $router.push({
          name: 'ProjectStructureDetails',
          params: {
            type: spatial_containers[$event.oldIndex].type,
            structure_id: id
          }
        })
      }) -->
      <v-chip
      v-for="element in spatial_containers"
      :key="element.name"
      :id="element.type+'#-1'"
      style="cursor: grab"
      color="rgb(30,30,30)"
      class="mr-1"
      >
      <v-icon small>{{getElementsIcon(element.type)}}</v-icon>
      <div v-if="$route.name === 'ProjectStructure'" class="ml-1">{{element.name}}</div>
    </v-chip>
    </draggable>
    <draggable
      :group="{name: 'spatial_elements', pull: 'clone', put: false}"
      :sort="false"
      animation="300"
      forceFallback="true"
      fallbackOnBody="true"
      :value="spatial_elements"
      @end="createUObject({
        url: [
          {[$event.to.id.split('#')[0]]: $event.to.id.split('#')[1]},
          {[$event.item.id.split('#')[0]]: ''},
          {showWithEntitiesNormalized: ''}
        ],
        url_prefix: `/projects/${project_id}/projectstructure`,
        u_object: JSON.parse(JSON.stringify(Object.assign(spatial_elements[$event.oldIndex], {order_index: $event.newIndex * 10 + 5, parent: {type: $event.to.id.split('#')[0], id: parseInt($event.to.id.split('#')[1])}})))
        })

        "
      >
      <!-- .then((id) => {
        $router.push({
          name: 'ProjectStructureDetails',
          params: {
            type: spatial_containers[$event.oldIndex].type,
            structure_id: id
          }
        })
      }) -->
      <v-chip
      v-for="element in spatial_elements"
      :key="element.name"
      :id="element.type+'#-1'"
      style="cursor: grab"
      color="rgb(30,30,30)"
      class="mr-1"
      >
      <v-icon small>{{getElementsIcon(element.type)}}</v-icon>
      <div v-if="$route.name === 'ProjectStructure'" class="ml-1">{{element.name}}</div>
    </v-chip>
    </draggable>
  </template>
  <template #main>
    <router-view/>
  </template>
  <template #sidebar-right>
    <div class="color-white-04" style="position: sticky; left: 0px">{{$t('Project.Structure.ProcessStructure.Header')}}</div>
    <!-- style="height: calc(100% - 30px); display: flex; flex-direction: column" -->
    <draggable
      :id="`projects#${project_id}`"
      :group="{name: 'trains', pull: false, put: function (to, from, dragEl) {return ['trains'].includes(dragEl.id.split('#')[0])}}"
      animation="300"
      forceFallback="true"
      fallbackOnBody="true"
      :disabled="!isEditMode || select_spatial_el_ta_id !== -1"
      :value="project.trains"
      style="position: relative; padding-bottom: 30px"
      filter=".ignore"
      @start="dragging = true"
      @end="dragging = false"
      @update="updateUObjectPosition({
          url: [
          {projects: project_id},
          {trains: project.trains[$event.oldIndex]},
          ],
          update: {
            position: $event.newIndex - $event.oldIndex
          }
        })"
      @add="$router.push({
          name: 'ProjectStructureAddTrain',
          params: {
            project_id: project_id,
            train_index: $event.newIndex,
            train_id: project.trains[$event.newIndex],
            direction: 0,
          }
        })"
      >
      <ProjectStructureTrain
        v-for="train in getUObjects({type: 'trains', ids: project.trains})"
        :key="train.id"
        :train="train"
        :isEditMode="isEditMode && select_spatial_el_ta_id === -1"
        @closeTrain="updateUDObject({
          url: [
            {projects: project_id},
            {trains: train.id}
          ],
          update: {
            closed: !train.closed
          }
        })"
        @changeValue="updateUObject({
            url: [
              {projects: project_id},
              {trains: train.id},
            ],
            update: {
              [$event.key]: $event.value
            }
          })"
      >
      <template #actions>
        <v-btn
          v-if="!train.closed"
          small
          style="height: 20px"
          @click="toggleAllTaktareas(train)"
          >
          <div>{{getUObject({type: 'taktareas', id: train.taktareas[0]}).closed?'open':'close'}} all</div>
        </v-btn>
        <StandardDeleteButton
          class="ml-2"
          v-if="isEditMode && select_spatial_el_ta_id === -1"
          :zoom="0.8"
          @clickDelete="deleteUObject({
              url: [
                {projects: project_id},
                {trains: train.id},
              ],
            })"
          />
      </template>
      <template #body>
        <!-- style="height: calc(100% - 30px); display: flex; flex-direction: column" -->
        <draggable
          :id="`trains#${train.id}`"
          :group="{name: 'taktareas', pull: false, put: function (to, from, dragEl) {return ['taktareas'].includes(dragEl.id.split('#')[0])}}"
          animation="300"
          forceFallback="true"
          fallbackOnBody="true"
          :disabled="!isEditMode || select_spatial_el_ta_id !== -1"
          :value="train.taktareas"
          style="position: relative; padding-bottom: 30px"
          @start="dragging = true"
          @end="dragging = false"
          @update="updateUObjectPosition({
              url: [
              {projects: project_id},
              {trains: train.id},
              {taktareas: train.taktareas[$event.oldIndex]},
              ],
              update: {
                position: $event.newIndex - $event.oldIndex
              }
              })"
          @add="createUObject({
            url: [
              {projects: project_id},
              {trains: train.id},
              {taktareas: 'copytaktareabulk'},
              {showWithEntitiesNormalized: ''}
            ],
            u_object: {
              taktarea_copy: $event.newIndex === 0?train.taktareas[0]:train.taktareas[$event.newIndex-1],
              taktareas: [{
                taktarea_start: getUObject({type: 'taktareas', id: $event.newIndex === 0?train.taktareas[0]:train.taktareas[$event.newIndex-1]}).taktarea_start + parseInt(1),
                position: $event.newIndex + parseInt(1)

                }]
            }
            })"
          >
          <ProjectStructureTaktarea
            v-for="taktarea in getUObjects({type: 'taktareas', ids: train.taktareas})"
            :key="taktarea.id"
            :taktarea="taktarea"
            :isEditMode="isEditMode && select_spatial_el_ta_id === -1"
            :hover="hover_ta_id === taktarea.id"
            :hover_el_id="hover_el_id"
            @closeTaktarea="updateUDObject({
              url: [
                {projects: project_id},
                {trains: train.id},
                {taktareas: taktarea.id},
              ],
              update: {
                closed: !taktarea.closed
              }
            })"
            @changeValue="updateUObject({
                url: [
                  {projects: project_id},
                  {trains: train.id},
                  {taktareas: taktarea.id},
                ],
                update: {
                  [$event.key]: $event.value
                }
              })"
            @mouseenter.native="dragging?'':taMouseEnter(taktarea)"
            @mouseleave.native="dragging?'':taMouseLeave()"
            >
            <template #waggons>
              <Waggon
                v-for="waggon in getUObjects({type: 'twaggons', ids: taktarea.twaggons})"
                :key="`waggon${waggon.id}`"
                :workpackage_count="waggon.tworkpackages.length"
                :zoom="0.5"
                >
                <template #content>
                  <WorkPackage
                    v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                    :key="`workpackage${workpackage.id}`"
                    :workpackage_count="waggon.tworkpackages.length"
                    :workpackage="workpackage"
                    :zoom="0.5"
                    />
                  </template>
                </Waggon>
            </template>
            <template #delete>
              <StandardDeleteButton
                class="ml-2"
                v-if="isEditMode && select_spatial_el_ta_id === -1"
                :zoom="0.8"
                @clickDelete="
                hover_ta_id = -1,
                deleteUObject({
                    url: [
                      {projects: project_id},
                      {trains: train.id},
                      {taktareas: taktarea.id},
                    ],
                  })"
                />
            </template>
            <template #body>
              <ProjectStructureTaktareaElement
                v-for="element in getUObjects({type: 'elements', ids: taktarea.elements})"
                :key="`element${element.id}`"
                :element="element"
              />
              <v-btn
                v-if="isEditMode"
                small
                :class="select_spatial_el_ta_id === taktarea.id?'green lighten-1':''"
                @click="select_spatial_el_ta_id === taktarea.id?
                (select_spatial_el_ta_id = -1, select_spatial_el_train_id = -1) : (select_spatial_el_ta_id = taktarea.id, select_spatial_el_train_id = train.id)
                "
                style="height: 20px"
                >
                <div v-if="select_spatial_el_ta_id === taktarea.id"><v-icon small>done</v-icon>done</div>
                <div v-else><v-icon small>add</v-icon>select</div>
              </v-btn>
            </template>
          </ProjectStructureTaktarea>
          <TFlex
            v-if="isEditMode"
            class="ignore"
            style="position: absolute; bottom: 0px; font-style: italic; color: rgba(0,0,0,0.4); margin-left: 24px"
            >
            <div style="overflow: hidden; white-space: nowrap">Drop or Select:</div>
            <v-chip
              style="cursor: pointer"
              color="rgba(0,0,0, 0.2)"
              class="ml-2"
              small
              @click="createUObject({
                url: [
                  {projects: project_id},
                  {trains: train.id},
                  {taktareas: 'copytaktareabulk'},
                  {showWithEntitiesNormalized: ''}
                ],
                u_object: {
                  taktarea_copy: train.taktareas[train.taktareas.length-1],
                  taktareas: [{
                    taktarea_start: getUObject({type: 'taktareas', id: train.taktareas[train.taktareas.length-1]}).taktarea_start + parseInt(1),
                    position: train.taktareas.length-1 + parseInt(1)
                    }]
                }
                })"
              >
              <div style="color: rgba(255,255,255,0.7)">Taktarea</div>
            </v-chip>
          </TFlex>
        </draggable>
      </template>
      </ProjectStructureTrain>
      <TFlex
        v-if="isEditMode"
        class="ignore"
        style="position: absolute; bottom: 0px; font-style: italic; color: rgba(0,0,0,0.4);"
        >
        <div style="overflow: hidden; white-space: nowrap">Drop or Select:</div>
        <v-chip
          style="cursor: pointer"
          color="rgba(0,0,0, 0.2)"
          class="ml-2"
          small
          @click="$router.push({
              name: 'ProjectStructureAddTrain',
              params: {
                project_id: project_id,
                train_index: 0,
                train_id: project.trains[0],
                direction: 0,
              }
            })"
          >
          <div style="color: rgba(255,255,255,0.7)">Train</div>
        </v-chip>
      </TFlex>
    </draggable>
  </template>
  <template #sidebar-right-footer v-if="isEditMode && select_spatial_el_ta_id === -1">
    <draggable
      :group="{name: 'process_structure', pull: 'clone', put: false}"
      :sort="false"
      animation="300"
      forceFallback="true"
      fallbackOnBody="true"
      :value="process_structure_elements"
      >
      <!-- @end="createUObject({
      url: [
      {[$event.to.id.split('#')[0]]: $event.to.id.split('#')[1]},
      {[$event.item.id.split('#')[0]]: ''},
      {showWithEntitiesNormalized: ''}
      ],
      url_prefix: `/projects/${project_id}/projectstructure`,
      u_object: JSON.parse(JSON.stringify(Object.assign(spatial_containers[$event.oldIndex], {order_index: $event.newIndex * 10 + 5, parent: {type: $event.to.id.split('#')[0], id: parseInt($event.to.id.split('#')[1])}})))
    }).then((id) => {
    $router.push({
    name: 'ProjectStructureDetails',
    params: {
    type: spatial_containers[$event.oldIndex].type,
    structure_id: id
  }
})
})" -->
      <v-chip
        v-for="element in process_structure_elements"
        :key="element.name"
        :id="element.type+'#-1'"
        style="cursor: grab"
        color="rgb(30,30,30)"
        class="mr-1"
        >
        <v-icon small>{{getElementsIcon(element.type)}}</v-icon>
        <div v-if="$route.name === 'ProjectStructure'" class="ml-1">{{element.name}}</div>
    </v-chip>
    </draggable>
  </template>
</ProjectStructure>
</template>
<script>
  import { ProjectStructureMixin } from '@/mixins/ProjectStructure.mixin.js'
  export default {
    props: ['project_id', 'project'],
    mixins: [
      ProjectStructureMixin,
    ],
    data: () => ({
    }),
    methods: {
    },
  }
</script>
